module.exports = __webpack_public_path__ + "static/media/14.e7ad4bb4.jpg";